// other — the approved primary lockup, vector (Other-Vector-Art, approved
// 2026-10-07). Never typeset or redrawn. 106px header, 98px compact minimum.
interface LogoProps {
  /** 106 by default; "compact" renders the 98px minimum. */
  size?: "default" | "compact";
  className?: string;
}

export function Logo({ size = "default", className }: LogoProps) {
  const width = size === "compact" ? 98 : 106;
  return (
    <img
      src="/brand/other-primary-lockup-black.svg"
      width={width}
      height={Math.round((width * 416.9) / 1000)}
      alt="other — merch. paper. gifts."
      className={className}
      draggable={false}
    />
  );
}
